module.exports = __webpack_public_path__ + "img/d2bf437.jpg";